var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.siteLocationsSrv.selectedLcoation
    ? _c(
        "div",
        { staticClass: "d-flex flex-column overflow-hidden height-100x" },
        [
          _c("div", { staticClass: "grey lighten-3 mb-4 flex-shrink-0" }, [
            _c(
              "div",
              { staticClass: "d-flex align-center results-header" },
              [
                _c(
                  "div",
                  { staticClass: "px-5" },
                  [
                    _c(
                      "v-row",
                      {
                        staticClass: "results-header-h1",
                        staticStyle: { width: "500px" },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex",
                            attrs: { lg: "12", cols: "6" },
                          },
                          [
                            _c("v-img", {
                              staticClass: "area-search header-img-title",
                              attrs: {
                                height: "20",
                                width: "20",
                                contain: "",
                                src: require("@/assets/icons/equipment-light.png"),
                              },
                            }),
                            _c("h2", { staticClass: "areaTitle" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SiteComponents.JunctionBoxDetails.Title"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      _vm._l(_vm.locationPath, function (path, index) {
                        return _c(
                          "div",
                          { key: path.id, staticClass: "d-flex" },
                          [
                            path.type === "site" && _vm.diagramViewStyle
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: "/images/plant.png",
                                  },
                                })
                              : _vm._e(),
                            path.type === "site" && !_vm.diagramViewStyle
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: require("@/assets/icons/plant-light.png"),
                                  },
                                })
                              : _vm.diagramViewStyle &&
                                path.type === "location" &&
                                index === _vm.locationPath.length - 1
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "20",
                                    width: "22",
                                    contain: "",
                                    src: "/images/equip.png",
                                  },
                                })
                              : !_vm.diagramViewStyle &&
                                path.type === "location" &&
                                index === _vm.locationPath.length - 1
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: require("@/assets/icons/equipment-light.png"),
                                  },
                                })
                              : _vm.diagramViewStyle &&
                                path.type === "location" &&
                                index < _vm.locationPath.length - 1
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: "/images/area.png",
                                  },
                                })
                              : !_vm.diagramViewStyle &&
                                path.type === "location" &&
                                index < _vm.locationPath.length - 1
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: require("@/assets/icons/area-light.png"),
                                  },
                                })
                              : _vm._e(),
                            path.type === "site"
                              ? _c("h4", { staticClass: "header-title-text" }, [
                                  _vm._v(_vm._s(path.title)),
                                ])
                              : _c(
                                  "span",
                                  {
                                    staticClass: "cursor-pointer",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "goToLocation",
                                          path.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "h4",
                                      { staticClass: "header-title-text" },
                                      [_vm._v(_vm._s(path.title))]
                                    ),
                                  ]
                                ),
                            index !== _vm.locationPath.length - 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "header-title-text next-arrow",
                                    staticStyle: {
                                      color: "white",
                                      padding: "0px 5px",
                                    },
                                  },
                                  [_vm._v(" > ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _c("v-spacer"),
                !_vm.readOnlyFlagValue
                  ? _c(
                      "div",
                      { staticClass: "px-3" },
                      [
                        _c(
                          "base-btn",
                          {
                            staticStyle: {
                              border: "1px solid white !important",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("saveJunctionBoxDetail")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("Common.Save")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.diagramViewStyle
                  ? _c(
                      "div",
                      { staticClass: "px-3" },
                      [
                        _c(
                          "base-btn",
                          {
                            staticStyle: {
                              padding: "0 !important",
                              border: "none",
                              height: "auto",
                              "min-width": "auto",
                              "background-color": "white !important",
                              "box-shadow": "none",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("fullPageFormView", true)
                              },
                            },
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                height: "16",
                                width: "16",
                                contain: "",
                                src: "/images/enlarge.png",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "base-btn",
                          {
                            staticStyle: {
                              padding: "0 !important",
                              border: "none",
                              height: "auto",
                              "min-width": "auto",
                              "background-color": "white !important",
                              "box-shadow": "none",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("goToLocation", null)
                              },
                            },
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                height: "36",
                                width: "36",
                                contain: "",
                                src: "/images/minus.png",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.siteLocationsSrv.locationDetailDataFieldStatuses.length > 0
              ? _c(
                  "div",
                  { staticClass: "warning-box" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "SiteComponents.JunctionBoxDetails.WarningCountMsg",
                            {
                              count:
                                _vm.siteLocationsSrv
                                  .locationDetailDataFieldStatuses.length,
                            }
                          )
                        ) + " "
                      ),
                    ]),
                    _c(
                      "base-btn",
                      {
                        attrs: { color: "#e17e2c", outlined: "", small: "" },
                        on: { click: _vm.summaryClick },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Common.Details")) + " ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm.siteLocationsSrv.selectedLcoation.junctionBoxDetail &&
          _vm.siteLocationsSrv.selectedLcoation.junctionBoxDetail.id
            ? _c(
                "div",
                {
                  key: "siteLocationsSrv.selectedLcoation.junctionBoxDetail.id || 0",
                  staticClass:
                    "flex-grow-1 flex-1 overflow-auto d-flex detailed-forms info-tabs-header",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col col-12" },
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "my-tabs min-height-100",
                          staticStyle: { "background-color": "white" },
                          attrs: {
                            vertical: _vm.diagramViewStyle ? false : true,
                          },
                        },
                        [
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("General Information")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Parent Area Information")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Warnings")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("JB Certification")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Tag Management")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Internet of Things")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Digital Twin")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Circuit")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Inspection History")]
                          ),
                          !_vm.diagramViewStyle
                            ? _c(
                                "v-tab",
                                {
                                  attrs: { "active-class": "side-tab-active" },
                                },
                                [_vm._v("Documentation")]
                              )
                            : _vm._e(),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Note")]
                          ),
                          !_vm.readOnlyFlagValue && _vm.diagramViewStyle
                            ? _c(
                                "div",
                                {
                                  staticClass: "px-3",
                                  staticStyle: { "margin-left": "auto" },
                                },
                                [
                                  _c(
                                    "base-btn",
                                    {
                                      staticStyle: {
                                        border: "1px solid white !important",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "saveJunctionBoxDetail"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Save")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation
                                .junctionBoxDetail
                                ? _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled: true,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation.id,
                                                      name: "equipmentID",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.EquipmentID.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation,
                                                          "id",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .title,
                                                      name: "areaName",
                                                      disabled: "",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.EquipmentName.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation,
                                                          "title",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      readonly: "",
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value: _vm.locationPath
                                                        .map((loc) => loc.title)
                                                        .join(" > "),
                                                      name: "locationName",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.Location.Label"
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Classification",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxClassification
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .classification,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.EquipmentClassification.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "classification",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "equipmentFieldEquipmentAssociatedApparatus",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxFieldAssociatedApparatus
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .fieldAssociatedApparatus,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.FieldEquipmentAssociatedApparatus.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "fieldAssociatedApparatus",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .manufacturer,
                                                      name: "equipManufacturer",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.Manufacturer.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "manufacturer",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .supplier,
                                                      name: "equipSupplier",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.Supplier.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "supplier",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .modelNo,
                                                      name: "equipModelNo",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.ModelNo.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "modelNo",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .serialNo,
                                                      name: "equipSerialNo",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.SerialNo.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "serialNo",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "divisionForRiskLevel",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxDivisionForRiskLevel
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .divisionForRiskLevel,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.DivisionForRiskLevel.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "divisionForRiskLevel",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-date-picker", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.InstalledDate.Label"
                                                      ),
                                                      name: "installedDate",
                                                      format: true,
                                                      formatStr: "yyyy-MM-dd",
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .installedDate,
                                                      max: _vm.$helpers.formatDate(
                                                        new Date().toISOString()
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "installedDate",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      !_vm.siteLocationsSrv.selectedLcoation
                                        .locationId
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-h4 text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SiteComponents.JunctionBoxDetails.NoParentAreaInfo"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm.siteLocationsSrv.selectedLcoation
                                            .parentLocation
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      name: "areaID",
                                                      disabled: "",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.AreaID.Label"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .locationId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation,
                                                          "locationId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.locationId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      name: "title",
                                                      disabled: "",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.AreaTitle.Label"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation.title,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation,
                                                          "title",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.title",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm.siteLocationsSrv
                                                .selectedLcoation
                                                .parentLocation &&
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.parentLocation
                                                .locationDetail
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "6" } },
                                                    [
                                                      _c("base-text-field", {
                                                        staticStyle: {
                                                          color: "#fdf7e7",
                                                        },
                                                        attrs: {
                                                          name: "lowAmbientTemp",
                                                          disabled: "",
                                                          label: _vm.$t(
                                                            "Fields.AreaFields.LowAmbientTemperature.Label"
                                                          ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .parentLocation
                                                              .locationDetail
                                                              .lowAmbientTemp,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .siteLocationsSrv
                                                                .selectedLcoation
                                                                .parentLocation
                                                                .locationDetail,
                                                              "lowAmbientTemp",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.lowAmbientTemp",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.siteLocationsSrv
                                                .selectedLcoation
                                                .parentLocation &&
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.parentLocation
                                                .locationDetail
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "6" } },
                                                    [
                                                      _c("base-text-field", {
                                                        staticStyle: {
                                                          color: "#fdf7e7",
                                                        },
                                                        attrs: {
                                                          name: "highAmbientTemp",
                                                          disabled: "",
                                                          label: _vm.$t(
                                                            "Fields.AreaFields.HighAmbientTemperature.Label"
                                                          ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .parentLocation
                                                              .locationDetail
                                                              .highAmbientTemp,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .siteLocationsSrv
                                                                .selectedLcoation
                                                                .parentLocation
                                                                .locationDetail,
                                                              "highAmbientTemp",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.highAmbientTemp",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.siteLocationsSrv
                                                .selectedLcoation
                                                .parentLocation &&
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.parentLocation
                                                .locationDetail
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _c("base-autocomplete", {
                                                        attrs: {
                                                          dense: "",
                                                          outlined: "",
                                                          items:
                                                            _vm
                                                              .adminDataFieldsSrv
                                                              .areaFieldOptions[
                                                              _vm.areaFieldsList
                                                                .areaIpx
                                                            ],
                                                          "item-text": "value",
                                                          "item-value": "id",
                                                          label: _vm.$t(
                                                            "Fields.AreaFields.Ipx.Label"
                                                          ),
                                                          "return-object": false,
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .parentLocation
                                                              .locationDetail
                                                              .ipx,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .siteLocationsSrv
                                                                .selectedLcoation
                                                                .parentLocation
                                                                .locationDetail,
                                                              "ipx",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.ipx",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.siteLocationsSrv
                                                .selectedLcoation
                                                .parentLocation &&
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.parentLocation
                                                .locationDetail
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _c("base-autocomplete", {
                                                        attrs: {
                                                          dense: "",
                                                          outlined: "",
                                                          items:
                                                            _vm
                                                              .adminDataFieldsSrv
                                                              .areaFieldOptions[
                                                              _vm.areaFieldsList
                                                                .areaIpy
                                                            ],
                                                          "item-text": "value",
                                                          "item-value": "id",
                                                          label: _vm.$t(
                                                            "Fields.AreaFields.Ipy.Label"
                                                          ),
                                                          "return-object": false,
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .parentLocation
                                                              .locationDetail
                                                              .ipy,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .siteLocationsSrv
                                                                .selectedLcoation
                                                                .parentLocation
                                                                .locationDetail,
                                                              "ipy",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.ipy",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaGasArea
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.GasArea.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .gasZone,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "gasZone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.gasZone",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaGasGroup
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.GasGroup.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .gasGroup,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "gasGroup",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.gasGroup",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaGasTemperatureClass
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.GasTempClass.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .gasTempClass,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "gasTempClass",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.gasTempClass",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaDustArea
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustArea.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustZone,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustZone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustZone",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaDustGroup
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustGroup.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustgroup,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustgroup",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustgroup",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      name: "dustCloudIgnitionTemp",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustCloudIgnitionTemperature.Label"
                                                      ),
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustCloudIgnitionTemp,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustCloudIgnitionTemp",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustCloudIgnitionTemp",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      name: "dustLayerDepth",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustLayerDepth.Label"
                                                      ),
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustLayerDepth,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustLayerDepth",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustLayerDepth",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      name: "dustLayerIgnitionTemp",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustLayerIgnitionTemperature.Label"
                                                      ),
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustLayerIgnitionTemp,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustLayerIgnitionTemp",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustLayerIgnitionTemp",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c("WarningsListComponent", {
                                attrs: {
                                  locationId:
                                    _vm.siteLocationsSrv.selectedLcoation.id,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation
                                .junctionBoxDetail
                                ? _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Certification Scheme",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxCertificationScheme
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .certificationScheme,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.CertificationScheme.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxCertificationScheme"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxCertificationScheme"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "certificationScheme",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .certificationNumber,
                                                      name: "certificationNumber",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.CertificationNumber.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "certificationNumber",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .lowAmbientTemperature,
                                                      name: "junctionBoxLowAmbientTemp",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.LowAmbientTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxLowAmbientTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxLowAmbientTemperature"
                                                        ),
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "lowAmbientTemperature",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .highAmbientTemperature,
                                                      name: "junctionBoxHighAmbientTemp",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.HighAmbientTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxHighAmbientTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxHighAmbientTemperature"
                                                        ),
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "highAmbientTemperature",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .lowServiceTemperature,
                                                      name: "junctionBoxLowServiceTemp",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.LowServiceTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxLowServiceTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxLowServiceTemperature"
                                                        ),
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "lowServiceTemperature",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .highServiceTemperature,
                                                      name: "junctionBoxHighServiceTemp",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.HighServiceTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxHighServiceTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxHighServiceTemperature"
                                                        ),
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "highServiceTemperature",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxCombinationOptionGas
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .combinationOptionGas,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.EquipmentCombinationOptionGas.Label"
                                                      ),
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "combinationOptionGas",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxInspectionFrequency
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .inspectionFrequency,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.EquipmentInspectionFrequency.Label"
                                                      ),
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "inspectionFrequency",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Protection Technique (Gas)",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxProtectionTechniqueGas
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .protectionTechniqueGas,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.ProtectionTechniqueGas.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxProtectionTechniqueGas"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxProtectionTechniqueGas"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "protectionTechniqueGas",
                                                          $event
                                                        )
                                                      },
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.siteLocationsSrv.selectedLcoation.junctionBoxDetail.protectionTechniqueEplGas =
                                                          []
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      name: "Protection Technique EPL (Gas)",
                                                      items:
                                                        _vm.adminDataFieldsSrv.getDependentItemsOf(
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxProtectionTechniqueEplGas,
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxProtectionTechniqueGas
                                                        ),
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .protectionTechniqueEplGas,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.ProtectionTechniqueEPLGas.Label"
                                                      ),
                                                      clearable: "",
                                                      disabled:
                                                        !_vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .protectionTechniqueGas ||
                                                        !_vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .protectionTechniqueGas
                                                          .length ||
                                                        _vm.readOnlyFlagValue,
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxProtectionTechniqueEplGas"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxProtectionTechniqueEplGas"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "protectionTechniqueEplGas",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Protection Technique (Dust)",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxProtectionTechniqueDust
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .protectionTechniqueDust,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.ProtectionTechniqueDust.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxProtectionTechniqueDust"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxProtectionTechniqueDust"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "protectionTechniqueDust",
                                                          $event
                                                        )
                                                      },
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.siteLocationsSrv.selectedLcoation.junctionBoxDetail.protectionTechniqueEplDust =
                                                          []
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      name: "Protection Technique EPL (Dust)",
                                                      items:
                                                        _vm.adminDataFieldsSrv.getDependentItemsOf(
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxProtectionTechniqueEplDust,
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxProtectionTechniqueDust
                                                        ),
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .protectionTechniqueEplDust,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.ProtectionTechniqueEPLDust.Label"
                                                      ),
                                                      clearable: "",
                                                      disabled:
                                                        !_vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .protectionTechniqueDust ||
                                                        !_vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .protectionTechniqueDust
                                                          .length ||
                                                        _vm.readOnlyFlagValue,
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxProtectionTechniqueEplDust"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxProtectionTechniqueEplDust"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "protectionTechniqueEplDust",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "EPL (Gas)",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxEplGas
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.EplGas.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .eplGas,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxEplGas"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxEplGas"
                                                        ),
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "eplGas",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Gas group",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxGasGroup
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.GasGroup.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .gasGroup,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxGasGroup"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxGasGroup"
                                                        ),
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "gasGroup",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "EPL (Dust)",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxEplDust
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.EplDust.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .eplDust,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxEplDust"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxEplDust"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "eplDust",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Dust Group",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxDustGroup
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.DustGroup.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .dustGroup,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxDustGroup"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxDustGroup"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "dustGroup",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "junctionBoxGasTemperatureClass",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxGasTempClass
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .gasTempClass,
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.GasTempClass.Label"
                                                      ),
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxGasTemperatureClass"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxGasTemperatureClass"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "gasTempClass",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      dense: "",
                                                      outlined: "",
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .maximumSurfaceTemperature,
                                                      name: "junctionBoxMaximumSurfaceTemperature",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.MaxSurfaceTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxMaxSurfaceTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxMaxSurfaceTemperature"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "maximumSurfaceTemperature",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxIpx
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .ipx,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.Ipx.Label"
                                                      ),
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxIpx"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxIpx"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "ipx",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .junctionBoxFieldOptions[
                                                          _vm
                                                            .junctionBoxFieldsList
                                                            .junctionBoxIpy
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .ipy,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.Ipy.Label"
                                                      ),
                                                      multiple: true,
                                                      limit: 2,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxIpy"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxIpy"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "ipy",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .testingDustLayerDepth,
                                                      name: "junctionBoxTestingDustLayerDepth",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.TestingDustLayerDepth.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxTestingDustLayerDepth"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxTestingDustLayerDepth"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "testingDustLayerDepth",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .junctionBoxDetail
                                                          .maximumSurfaceTemperatureWithDustLayer,
                                                      name: "junctionBoxMaxSurfaceTemperatureWithDustLayer",
                                                      label: _vm.$t(
                                                        "Fields.JunctionBox.MaxSurfaceTemperatureWithDustLayer.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxMaxSurfaceTempWithDustLayer"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "junctionBoxMaxSurfaceTempWithDustLayer"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .junctionBoxDetail,
                                                          "maximumSurfaceTemperatureWithDustLayer",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "MiscellaneousCertificationComponent",
                                            {
                                              attrs: {
                                                "read-only":
                                                  _vm.readOnlyFlagValue,
                                              },
                                            }
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation.id
                                ? _c("TagManagementComponent", {
                                    key: _vm.siteLocationsSrv.selectedLcoation
                                      .id,
                                    attrs: {
                                      siteLocationId:
                                        _vm.siteLocationsSrv.selectedLcoation
                                          .id,
                                      readOnlyFlagValue: _vm.readOnlyFlagValue,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation
                                .junctionBoxDetail
                                ? _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c("v-card-text", [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _vm.siteLocationsSrv
                                                  .selectedLcoation.id
                                                  ? _c(
                                                      "sensor-management-component",
                                                      {
                                                        key: _vm
                                                          .siteLocationsSrv
                                                          .selectedLcoation.id,
                                                        attrs: {
                                                          siteLocationId:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .id,
                                                          readOnlyFlagValue:
                                                            _vm.readOnlyFlagValue,
                                                        },
                                                      }
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation
                                .junctionBoxDetail
                                ? _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c("DigitalTwinCanvasComponent", {
                                        key: _vm.siteLocationsSrv
                                          .selectedLcoation.id,
                                        attrs: {
                                          siteLocationId:
                                            _vm.siteLocationsSrv
                                              .selectedLcoation.id,
                                          readOnlyFlagValue:
                                            _vm.readOnlyFlagValue,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-sheet",
                                                {
                                                  staticClass: "mx-auto",
                                                  attrs: { "max-width": "300" },
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "SiteComponents.JunctionBoxDetails.TotalWireEntries"
                                                            )
                                                          ) +
                                                          ": " +
                                                          _vm._s(
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .wiringCables
                                                              ?.length
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-slide-group",
                                                    {
                                                      attrs: {
                                                        "slider-color":
                                                          "#1b3054",
                                                        "show-arrows": "",
                                                        centered: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "prev",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      text: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.prev()
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-chevron-left"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                          {
                                                            key: "next",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      text: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.next()
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-chevron-right"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        1796914642
                                                      ),
                                                      model: {
                                                        value: _vm.tab,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.tab = $$v
                                                        },
                                                        expression: "tab",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.siteLocationsSrv
                                                        .selectedLcoation
                                                        .wiringCables,
                                                      function (entry) {
                                                        return _c(
                                                          "v-slide-item",
                                                          {
                                                            key: entry.id,
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function ({
                                                                    active,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "tab-cable",
                                                                          attrs:
                                                                            {
                                                                              "input-value":
                                                                                active,
                                                                              "active-class":
                                                                                "tab-cable-active",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.setActive(
                                                                                  entry.id
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                entry?.name ??
                                                                                  "Core 1"
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          !_vm.readOnlyFlagValue
                                            ? _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-right",
                                                  staticStyle: {
                                                    "justify-content": "right",
                                                    position: "absolute",
                                                    right: "5px",
                                                  },
                                                  attrs: { cols: "2" },
                                                },
                                                [
                                                  _c(
                                                    "base-btn",
                                                    {
                                                      staticStyle: {
                                                        "margin-right": "12px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.setNew()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Common.AddWire"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      !_vm.showAddNew
                                        ? _c(
                                            "v-tabs-items",
                                            {
                                              model: {
                                                value: _vm.tab,
                                                callback: function ($$v) {
                                                  _vm.tab = $$v
                                                },
                                                expression: "tab",
                                              },
                                            },
                                            _vm._l(
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.wiringCables,
                                              function (entry, index) {
                                                return _c(
                                                  "v-tab-item",
                                                  { key: entry.id },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          [
                                                            _c(
                                                              "v-row",
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          value:
                                                                            entry.id,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.CableID.Label"
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "id",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          value:
                                                                            entry.name,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.CableName.Label"
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "name",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "flex-grow-1",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          name: "wiringCableEntryType",
                                                                          items:
                                                                            _vm
                                                                              .adminDataFieldsSrv
                                                                              .equipmentFieldOptions[
                                                                              _vm
                                                                                .equipmentFieldsList
                                                                                .equipmentWiringCableEntryType
                                                                            ],
                                                                          value:
                                                                            entry.cableType,
                                                                          "item-text":
                                                                            "value",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.CableEntryType.Label"
                                                                            ),
                                                                          clearable:
                                                                            "",
                                                                          "return-object": false,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "cableType",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.Manufacturer.Label"
                                                                            ),
                                                                          value:
                                                                            entry.manufacturer,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "manufacturer",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.ModelNo.Label"
                                                                            ),
                                                                          value:
                                                                            entry.modelNo,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "modelNo",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.SerialNo.Label"
                                                                            ),
                                                                          value:
                                                                            entry.serialNo,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "serialNo",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.CertificationNo.Label"
                                                                            ),
                                                                          value:
                                                                            entry.certificationNo,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "certificationNo",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "flex-grow-1",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          name: "wiringProtectionType",
                                                                          items:
                                                                            _vm
                                                                              .adminDataFieldsSrv
                                                                              .equipmentFieldOptions[
                                                                              _vm
                                                                                .equipmentFieldsList
                                                                                .equipmentWiringCableProtectionType
                                                                            ],
                                                                          value:
                                                                            entry.protectionType,
                                                                          "item-text":
                                                                            "value",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.ProtectionType.Label"
                                                                            ),
                                                                          clearable:
                                                                            "",
                                                                          "return-object": false,
                                                                          "error-count":
                                                                            _vm.siteLocationsSrv.checkFieldError(
                                                                              "equipmentWiringCableProtectionType",
                                                                              entry.id
                                                                            )
                                                                              .length ??
                                                                            1,
                                                                          "error-messages":
                                                                            _vm.siteLocationsSrv.checkFieldError(
                                                                              "equipmentWiringCableProtectionType",
                                                                              entry.id
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "protectionType",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.CableModelNo.Label"
                                                                            ),
                                                                          value:
                                                                            entry.cableModelNo,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "cableModelNo",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "flex-grow-1",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          name: "equipmentWiringCableFunction",
                                                                          items:
                                                                            _vm
                                                                              .adminDataFieldsSrv
                                                                              .equipmentFieldOptions[
                                                                              _vm
                                                                                .equipmentFieldsList
                                                                                .equipmentWiringCableFunction
                                                                            ],
                                                                          value:
                                                                            entry.cableFunction,
                                                                          "item-text":
                                                                            "value",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            "Core Function",
                                                                          clearable:
                                                                            "",
                                                                          "return-object": false,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "cableFunction",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            color:
                                                                              "#fdf7e7",
                                                                          },
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.CableManufacturer.Label"
                                                                            ),
                                                                          value:
                                                                            entry.cableManufacturer,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "cableManufacturer",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            color:
                                                                              "#fdf7e7",
                                                                          },
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.CableEntryType.Label"
                                                                            ),
                                                                          value:
                                                                            entry.coreInformation,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "coreInformation",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "12",
                                                                    },
                                                                    on: {
                                                                      dragover:
                                                                        _vm.allowDrop,
                                                                      drop: _vm.drop,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "h3",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "margin-bottom":
                                                                              "10px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "SiteComponents.JunctionBoxDetails.ConnectWith"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          items:
                                                                            _vm.getEquipmentsList,
                                                                          value:
                                                                            entry.connectWith,
                                                                          "item-text":
                                                                            "title",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.SelectEquipDP.Label"
                                                                            ),
                                                                          "return-object": false,
                                                                          multiple: false,
                                                                          clearable:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "connectWith",
                                                                                $event
                                                                              )
                                                                            },
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.makeConnectWithFields(
                                                                                entry,
                                                                                index
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "12",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          loading:
                                                                            _vm.loadingConnectLists,
                                                                          items:
                                                                            _vm
                                                                              .finalList[
                                                                              index
                                                                            ],
                                                                          value:
                                                                            entry.connectWithMid,
                                                                          "item-text":
                                                                            "title",
                                                                          "item-value":
                                                                            "id",
                                                                          clearable:
                                                                            "",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.SelectOutputEntries.Label"
                                                                            ),
                                                                          "return-object": false,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "connectWithMid",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "12",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          items:
                                                                            [
                                                                              "IN",
                                                                              "OUT",
                                                                              "N/A",
                                                                            ],
                                                                          value:
                                                                            entry.connectDirection,
                                                                          "item-text":
                                                                            "value",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.JunctionBox.Direction.Label"
                                                                            ),
                                                                          clearable:
                                                                            "",
                                                                          "return-object": false,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "connectDirection",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "30px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "24px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Common.Documents"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                !_vm.addDocument
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        staticClass:
                                                                          "white--text",
                                                                        attrs: {
                                                                          color:
                                                                            "admin-primary ",
                                                                          icon: "",
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              _vm.addDocument = true
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {},
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-plus-circle-outline"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _vm.addDocument
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mb-2",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-row",
                                                                      [
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "4",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "base-autocomplete",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    disabled:
                                                                                      _vm.readOnlyFlagValue,
                                                                                    dense:
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    clearable:
                                                                                      "",
                                                                                    rules:
                                                                                      "required",
                                                                                    items:
                                                                                      _vm.documentTypes,
                                                                                    value:
                                                                                      _vm.selectedType,
                                                                                    label:
                                                                                      _vm.$t(
                                                                                        "Fields.JunctionBox.DocumentType.Label"
                                                                                      ),
                                                                                    "return-object": false,
                                                                                  },
                                                                                on: {
                                                                                  "update:value":
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.selectedType =
                                                                                        $event
                                                                                    },
                                                                                },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "4",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-file-input",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    dense:
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    disabled:
                                                                                      _vm.readOnlyFlagValue,
                                                                                    placeholder:
                                                                                      "Upload your documents",
                                                                                    label:
                                                                                      "File input",
                                                                                    "prepend-icon":
                                                                                      "mdi-paperclip",
                                                                                  },
                                                                                on: {
                                                                                  change:
                                                                                    _vm.filesSelected,
                                                                                },
                                                                                scopedSlots:
                                                                                  _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key: "selection",
                                                                                        fn: function ({
                                                                                          text,
                                                                                        }) {
                                                                                          return [
                                                                                            _c(
                                                                                              "v-chip",
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    small:
                                                                                                      "",
                                                                                                    label:
                                                                                                      "",
                                                                                                    color:
                                                                                                      "primary",
                                                                                                  },
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      text
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        },
                                                                                      },
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  ),
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex justify-end",
                                                                            attrs:
                                                                              {
                                                                                cols: "4",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                staticClass:
                                                                                  "white--text mr-1",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "admin-primary ",
                                                                                    disabled:
                                                                                      !_vm.selectedType ||
                                                                                      !_vm.file,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.upload(
                                                                                        entry.id ||
                                                                                          ""
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Save "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                staticClass:
                                                                                  "white--text",
                                                                                attrs:
                                                                                  {
                                                                                    outlined:
                                                                                      "",
                                                                                    color:
                                                                                      "admin-primary",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.reset,
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Cancel "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-divider"
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _vm._l(
                                                              _vm.documents.filter(
                                                                (docs) =>
                                                                  docs.equipmentWiringCableId ===
                                                                  entry.id
                                                              ),
                                                              function (
                                                                document
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: `${document.id}`,
                                                                    staticStyle:
                                                                      {
                                                                        "margin-top":
                                                                          "10px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Documents - " +
                                                                          _vm._s(
                                                                            document.documentType
                                                                          ) +
                                                                          " - "
                                                                      ),
                                                                    ]),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          document.title
                                                                        )
                                                                      ),
                                                                    ]),
                                                                    _c(
                                                                      "base-btn",
                                                                      {
                                                                        staticClass:
                                                                          "mr-1",
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          icon: "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.view(
                                                                                document
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "admin-primary--text cursor-pointer",
                                                                            attrs:
                                                                              {
                                                                                size: "16px",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-eye"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    !_vm.readOnlyFlagValue
                                                                      ? _c(
                                                                          "base-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.deleteDoc(
                                                                                    document
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "red lighten-1",
                                                                                    size: "16px",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-delete-empty"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                        !_vm.readOnlyFlagValue
                                                          ? _c(
                                                              "v-card-actions",
                                                              [
                                                                _c("v-spacer"),
                                                                _c(
                                                                  "base-btn",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "background-color":
                                                                          "#fff !important",
                                                                        color:
                                                                          "#1b3054",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.deleteCable(
                                                                            entry
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Common.Delete"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "base-btn",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateCable(
                                                                            entry
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Common.Update"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.showAddNew
                                        ? _c(
                                            "v-sheet",
                                            {
                                              staticStyle: {
                                                "margin-top": "20px",
                                              },
                                              attrs: { elevation: "0" },
                                            },
                                            [
                                              _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-autocomplete",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    "item-text":
                                                                      "sequence",
                                                                    "item-value":
                                                                      "sequence",
                                                                    items:
                                                                      _vm
                                                                        .siteLocationsSrv
                                                                        .selectedLcoation
                                                                        .wiringCables,
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    small: "",
                                                                    clearable:
                                                                      "",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.AddBeforeWire.Label"
                                                                      ),
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "item",
                                                                          fn: function ({
                                                                            item,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-list-item-content",
                                                                                [
                                                                                  _c(
                                                                                    "v-list-item-title",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          `Wire ${
                                                                                            item.sequence ??
                                                                                            1
                                                                                          }`
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                        {
                                                                          key: "selection",
                                                                          fn: function ({
                                                                            item,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-chip",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      small:
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " Wire " +
                                                                                      _vm._s(
                                                                                        item.sequence ??
                                                                                          1
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      false,
                                                                      3939495591
                                                                    ),
                                                                  model: {
                                                                    value:
                                                                      _vm.newSeq,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.newSeq =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "newSeq",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .name,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.CableName.Label"
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "name",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.Manufacturer.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .manufacturer,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "manufacturer",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.ModelNo.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .modelNo,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "modelNo",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.SerialNo.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .serialNo,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "serialNo",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.CertificationNo.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .certificationNo,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "certificationNo",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    name: "wiringProtectionTypeAdd",
                                                                    items:
                                                                      _vm
                                                                        .adminDataFieldsSrv
                                                                        .equipmentFieldOptions[
                                                                        _vm
                                                                          .equipmentFieldsList
                                                                          .equipmentWiringCableProtectionType
                                                                      ],
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .protectionType,
                                                                    "item-text":
                                                                      "value",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.ProtectionType.Label"
                                                                      ),
                                                                    clearable:
                                                                      "",
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "protectionType",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.CableModelNo.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .cableModelNo,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "cableModelNo",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    name: "equipmentWiringCableFunctionAdd",
                                                                    items:
                                                                      _vm
                                                                        .adminDataFieldsSrv
                                                                        .equipmentFieldOptions[
                                                                        _vm
                                                                          .equipmentFieldsList
                                                                          .equipmentWiringCableFunction
                                                                      ],
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .cableFunction,
                                                                    "item-text":
                                                                      "value",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.CableFunction.Label"
                                                                      ),
                                                                    clearable:
                                                                      "",
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "cableFunction",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#fdf7e7",
                                                                  },
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.CableManufacturer.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .cableManufacturer,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "cableManufacturer",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    name: "wiringCableEntryTypeAdd",
                                                                    items:
                                                                      _vm
                                                                        .adminDataFieldsSrv
                                                                        .equipmentFieldOptions[
                                                                        _vm
                                                                          .equipmentFieldsList
                                                                          .equipmentWiringCableEntryType
                                                                      ],
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .coreInformation,
                                                                    "item-text":
                                                                      "value",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.CableEntryType.Label"
                                                                      ),
                                                                    clearable:
                                                                      "",
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "coreInformation",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                              },
                                                              on: {
                                                                dragover:
                                                                  _vm.allowDrop,
                                                                drop: _vm.dropNew,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "h3",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-bottom":
                                                                      "10px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Connect With"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    items:
                                                                      _vm.getEquipmentsList,
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .connectWith,
                                                                    "item-text":
                                                                      "title",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.SelectEquipDP.Label"
                                                                      ),
                                                                    "return-object": false,
                                                                    multiple: false,
                                                                    clearable:
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "connectWith",
                                                                          $event
                                                                        )
                                                                      },
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.makeConnectWithFieldsNew(
                                                                          _vm
                                                                            .newWiringCableObj1
                                                                            .connectWith
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    loading:
                                                                      _vm.loadingConnectLists,
                                                                    items:
                                                                      _vm.finalListNew,
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .connectWithMid,
                                                                    "item-text":
                                                                      "title",
                                                                    "item-value":
                                                                      "id",
                                                                    clearable:
                                                                      "",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.SelectOutputEntries.Label"
                                                                      ),
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "connectWithMid",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    items: [
                                                                      "IN",
                                                                      "OUT",
                                                                      "N/A",
                                                                    ],
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .connectDirection,
                                                                    "item-text":
                                                                      "value",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.JunctionBox.Direction.Label"
                                                                      ),
                                                                    clearable:
                                                                      "",
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "connectDirection",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.readOnlyFlagValue
                                                    ? _c(
                                                        "v-card-actions",
                                                        [
                                                          _c("v-spacer"),
                                                          _c(
                                                            "base-btn",
                                                            {
                                                              on: {
                                                                click:
                                                                  _vm.saveNewCable,
                                                              },
                                                            },
                                                            [_vm._v("Save")]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("PreviewDocumentDialogComponent", {
                                ref: "previewDialog",
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [_c("InspectionHistoryComponent")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-card-title",
                                                { staticClass: "pt-0" },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "text-h5 my-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SiteComponents.JunctionBoxDetails.JunctionBoxDocuments"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-spacer"),
                                                  _c(
                                                    "span",
                                                    { staticClass: "ml-auto" },
                                                    [
                                                      !_vm.addDocument1
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "white--text",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.readOnlyFlagValue,
                                                                color:
                                                                  "admin-primary ",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.addDocument1 = true
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "Common.AddDocument"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "ml-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-plus-circle-outline"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-card-text", [
                                            _vm.addDocument1
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mb-2" },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "4",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "base-autocomplete",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.readOnlyFlagValue,
                                                                  dense: "",
                                                                  outlined: "",
                                                                  clearable: "",
                                                                  rules:
                                                                    "required",
                                                                  items:
                                                                    _vm.documentTypes,
                                                                  value:
                                                                    _vm.selectedType,
                                                                  label:
                                                                    "Document Type",
                                                                  "return-object": false,
                                                                },
                                                                on: {
                                                                  "update:value":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectedType =
                                                                        $event
                                                                    },
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "4",
                                                            },
                                                          },
                                                          [
                                                            _c("v-file-input", {
                                                              attrs: {
                                                                dense: "",
                                                                outlined: "",
                                                                disabled:
                                                                  _vm.readOnlyFlagValue,
                                                                placeholder:
                                                                  "Upload your documents",
                                                                label:
                                                                  "File input",
                                                                "prepend-icon":
                                                                  "mdi-paperclip",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.filesSelected,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "selection",
                                                                      fn: function ({
                                                                        text,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-chip",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  small:
                                                                                    "",
                                                                                  label:
                                                                                    "",
                                                                                  color:
                                                                                    "primary",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    text
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  1464597600
                                                                ),
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "d-flex justify-end",
                                                            attrs: {
                                                              cols: "4",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "white--text mr-1",
                                                                attrs: {
                                                                  color:
                                                                    "admin-primary ",
                                                                  disabled:
                                                                    !_vm.selectedType ||
                                                                    !_vm.file,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.uploadEquip()
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v(" Save ")]
                                                            ),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "white--text",
                                                                attrs: {
                                                                  outlined: "",
                                                                  color:
                                                                    "admin-primary",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.addDocument1 = false
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Cancel "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-divider"),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c("div", [
                                              _c(
                                                "table",
                                                { staticClass: "foex-table" },
                                                [
                                                  _c("thead", [
                                                    _c("tr", [
                                                      _c("th", [
                                                        _vm._v("Type"),
                                                      ]),
                                                      _c("th", [
                                                        _vm._v("File"),
                                                      ]),
                                                      _c("th", [
                                                        _vm._v("Actions"),
                                                      ]),
                                                    ]),
                                                  ]),
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      _vm.documents.filter(
                                                        (docs) =>
                                                          docs.equipmentWiringCableId ===
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            ?.id
                                                      ),
                                                      function (document) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key: `${document.id}`,
                                                          },
                                                          [
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  document.documentType
                                                                )
                                                              ),
                                                            ]),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  document.title
                                                                )
                                                              ),
                                                            ]),
                                                            _c(
                                                              "td",
                                                              [
                                                                _c(
                                                                  "base-btn",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      small: "",
                                                                      icon: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.view(
                                                                            document
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "admin-primary--text cursor-pointer",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-eye"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      icon: "",
                                                                      small: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.downloadDoc(
                                                                            document
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "admin-primary--text cursor-pointer",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-download"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      icon: "",
                                                                      small: "",
                                                                      disabled:
                                                                        _vm.readOnlyFlagValue,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.deleteDoc(
                                                                            document
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "red lighten-1",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-delete-empty"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c("v-divider", {
                                        staticClass: "purple-divider",
                                        staticStyle: {
                                          "margin-top": "30px",
                                          "margin-bottom": "12px",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "bg-even" },
                                        [
                                          _c(
                                            "v-row",
                                            {},
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "-10px",
                                                  },
                                                  attrs: { cols: "12" },
                                                },
                                                [
                                                  _c(
                                                    "v-card-title",
                                                    { staticClass: "pt-0" },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "text-h5 my-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "SiteComponents.JunctionBoxDetails.WiringDocuments"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            {},
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "v-sheet",
                                                    {
                                                      staticClass: "mx-auto",
                                                      attrs: {
                                                        "max-width": "300",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-slide-group",
                                                        {
                                                          attrs: {
                                                            "slider-color":
                                                              "#1b3054",
                                                            "show-arrows": "",
                                                            centered: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "prev",
                                                                fn: function () {
                                                                  return [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          text: "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.prev()
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-chevron-left"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                                proxy: true,
                                                              },
                                                              {
                                                                key: "next",
                                                                fn: function () {
                                                                  return [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          text: "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.next()
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-chevron-right"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                                proxy: true,
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            1796914642
                                                          ),
                                                          model: {
                                                            value: _vm.tab,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.tab = $$v
                                                            },
                                                            expression: "tab",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .wiringCables,
                                                          function (entry) {
                                                            return _c(
                                                              "v-slide-item",
                                                              {
                                                                key: entry.id,
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function ({
                                                                          active,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                staticClass:
                                                                                  "tab-cable",
                                                                                attrs:
                                                                                  {
                                                                                    "input-value":
                                                                                      active,
                                                                                    "active-class":
                                                                                      "tab-cable-active",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.setActive(
                                                                                        entry.id
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Wire " +
                                                                                    _vm._s(
                                                                                      entry?.sequence ??
                                                                                        1
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            {},
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticStyle: {
                                                    "padding-top": "0",
                                                    "padding-bottom": "0",
                                                  },
                                                  attrs: { cols: "12" },
                                                },
                                                [
                                                  _c(
                                                    "v-card-title",
                                                    { staticClass: "pt-0" },
                                                    [
                                                      _c("v-spacer"),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ml-auto",
                                                        },
                                                        [
                                                          !_vm.addDocument
                                                            ? _c(
                                                                "v-btn",
                                                                {
                                                                  staticClass:
                                                                    "white--text",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    outlined:
                                                                      "",
                                                                    color:
                                                                      "admin-primary",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.addDocument = true
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Common.AddDocument"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticClass:
                                                                        "ml-1",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-plus-circle-outline"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-tabs-items",
                                            {
                                              model: {
                                                value: _vm.tab,
                                                callback: function ($$v) {
                                                  _vm.tab = $$v
                                                },
                                                expression: "tab",
                                              },
                                            },
                                            _vm._l(
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.wiringCables,
                                              function (entry) {
                                                return _c(
                                                  "v-tab-item",
                                                  { key: entry.id },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        staticClass: "bg-even",
                                                      },
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          [
                                                            _vm.addDocument
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mb-2",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-row",
                                                                      [
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "4",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "base-autocomplete",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    disabled:
                                                                                      _vm.readOnlyFlagValue,
                                                                                    dense:
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    clearable:
                                                                                      "",
                                                                                    rules:
                                                                                      "required",
                                                                                    items:
                                                                                      _vm.documentTypes,
                                                                                    value:
                                                                                      _vm.selectedType,
                                                                                    label:
                                                                                      "Document Type",
                                                                                    "return-object": false,
                                                                                  },
                                                                                on: {
                                                                                  "update:value":
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.selectedType =
                                                                                        $event
                                                                                    },
                                                                                },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "4",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-file-input",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    dense:
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    disabled:
                                                                                      _vm.readOnlyFlagValue,
                                                                                    placeholder:
                                                                                      "Upload your documents",
                                                                                    label:
                                                                                      "File input",
                                                                                    "prepend-icon":
                                                                                      "mdi-paperclip",
                                                                                  },
                                                                                on: {
                                                                                  change:
                                                                                    _vm.filesSelected,
                                                                                },
                                                                                scopedSlots:
                                                                                  _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key: "selection",
                                                                                        fn: function ({
                                                                                          text,
                                                                                        }) {
                                                                                          return [
                                                                                            _c(
                                                                                              "v-chip",
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    small:
                                                                                                      "",
                                                                                                    label:
                                                                                                      "",
                                                                                                    color:
                                                                                                      "primary",
                                                                                                  },
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      text
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        },
                                                                                      },
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  ),
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex justify-end",
                                                                            attrs:
                                                                              {
                                                                                cols: "4",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                staticClass:
                                                                                  "white--text mr-1",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "admin-primary ",
                                                                                    disabled:
                                                                                      !_vm.selectedType ||
                                                                                      !_vm.file,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.upload(
                                                                                        entry.id ||
                                                                                          ""
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Save "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                staticClass:
                                                                                  "white--text",
                                                                                attrs:
                                                                                  {
                                                                                    outlined:
                                                                                      "",
                                                                                    color:
                                                                                      "admin-primary",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.addDocument = false
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Cancel "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-divider"
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _c("v-col", [
                                                              _c(
                                                                "table",
                                                                {
                                                                  staticClass:
                                                                    "foex-table",
                                                                },
                                                                [
                                                                  _c("thead", [
                                                                    _c("tr", [
                                                                      _c("th", [
                                                                        _vm._v(
                                                                          "Type"
                                                                        ),
                                                                      ]),
                                                                      _c("th", [
                                                                        _vm._v(
                                                                          "File"
                                                                        ),
                                                                      ]),
                                                                      _c("th", [
                                                                        _vm._v(
                                                                          "Actions"
                                                                        ),
                                                                      ]),
                                                                    ]),
                                                                  ]),
                                                                  _c(
                                                                    "tbody",
                                                                    _vm._l(
                                                                      _vm.documents.filter(
                                                                        (
                                                                          docs
                                                                        ) =>
                                                                          docs.equipmentWiringCableId ===
                                                                          entry.id
                                                                      ),
                                                                      function (
                                                                        document
                                                                      ) {
                                                                        return _c(
                                                                          "tr",
                                                                          {
                                                                            key: `${document.id}`,
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    document.documentType
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    document.title
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _c(
                                                                                  "base-btn",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mr-1",
                                                                                    attrs:
                                                                                      {
                                                                                        small:
                                                                                          "",
                                                                                        icon: "",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.view(
                                                                                            document
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-icon",
                                                                                      {
                                                                                        staticClass:
                                                                                          "admin-primary--text cursor-pointer",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "mdi-eye"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _c(
                                                                                  "v-btn",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mr-1",
                                                                                    attrs:
                                                                                      {
                                                                                        icon: "",
                                                                                        small:
                                                                                          "",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.downloadDoc(
                                                                                            document
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-icon",
                                                                                      {
                                                                                        staticClass:
                                                                                          "admin-primary--text cursor-pointer",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "mdi-download"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                !_vm.readOnlyFlagValue
                                                                                  ? _c(
                                                                                      "v-btn",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            icon: "",
                                                                                            small:
                                                                                              "",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.deleteDoc(
                                                                                                document
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-icon",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                color:
                                                                                                  "red lighten-1",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "mdi-delete-empty"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("v-divider", {
                                        staticClass: "mb-10 purple-divider",
                                        staticStyle: {
                                          "border-width": "1px !important",
                                        },
                                      }),
                                      _c("T3DModelDocumentsComponent", {
                                        attrs: {
                                          locationId:
                                            _vm.siteLocationsSrv
                                              .selectedLcoation.id,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("PreviewDocumentDialogComponent", {
                                ref: "previewDialog",
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("base-textarea", {
                                                attrs: {
                                                  disabled:
                                                    _vm.readOnlyFlagValue,
                                                  outlined: "",
                                                  rows: "5",
                                                  label: _vm.$t(
                                                    "Fields.JunctionBox.Note.Label"
                                                  ),
                                                  "auto-grow": "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.siteLocationsSrv
                                                      .selectedLcoation
                                                      .junctionBoxDetail.note,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.siteLocationsSrv
                                                        .selectedLcoation
                                                        .junctionBoxDetail,
                                                      "note",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "siteLocationsSrv.selectedLcoation.junctionBoxDetail.note",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "junction-box-report-component",
                                                {
                                                  attrs: {
                                                    siteId:
                                                      _vm.siteLocationsSrv
                                                        .selectedLcoation
                                                        .siteId,
                                                    junctionBoxId:
                                                      _vm.siteLocationsSrv
                                                        .selectedLcoation.id,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _c("AreaRulesSummaryDialogComponent", {
            ref: "areaRulesSummaryDialogRef",
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }